import { getStatusVariant } from './company-status.constants'
import React from 'react'

import { CompanyStatus } from '@/gen/inventory/v1/company_status_pb'

import { companyStatusLabel } from '@/const/label'

import { Badge, BadgeProps } from '@/components/lemmala-design-system/badge/badge'

type CompanyStatusBadgeProps = {
  status: CompanyStatus
} & BadgeProps

export const CompanyStatusBadge = React.forwardRef<HTMLDivElement, CompanyStatusBadgeProps>(
  ({ status, className, variant, badgeStyle, ...props }, ref) => {
    const label = companyStatusLabel[status]
    // Don't show badge if there's no configuration or if it's UNSPECIFIED (empty label)
    if (status === CompanyStatus.UNSPECIFIED || !label) return null

    return (
      <Badge
        ref={ref}
        variant={variant ?? getStatusVariant(status)}
        badgeStyle={badgeStyle ?? 'subtle'}
        textCase='title'
        className={className}
        {...props}
      >
        {label}
      </Badge>
    )
  },
)
CompanyStatusBadge.displayName = 'CompanyStatusBadge'
